import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import {CourseToolsMixin} from '@/courses/mixins/course-tools.mixin';
import Moment from 'moment';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import { COMPONENT_TYPE } from '@/courses/values/courses.values';
import { Status } from '@/models/status.model';
import EdLessonCreator from '@/content/pages/create-lesson/routes/ed-lesson-creator/ed-lesson-creator.vue';

@Component({
  name: 'ed-subject-day-content',
  components: {
    EdLessonCreator
  }
})
export default class EdSubjectDayContentComponent extends Mixins(CourseToolsMixin) {

  @Prop() readonly params: any;

  public allowEdit: boolean = false;  //TODO: Allow edit in future Builder versions
  public sectionOptions: any = new EdSectionOptions(this.allowEdit);
  public contentType: string = 'DAY_CONTENT';
  public saving: boolean = false;
  public loading: boolean = true;
  public sections: any = [];
  public objectsTagged: any = [];
  public objectOptions = { 
    draggable: true,
    selectable: false,
    editable: true
  };
  public addingSection: boolean = false;

  get classId() {
    return this.params.classId ? this.params.classId : 0;
  }

  get dateTitle() {
    let lan = this.$i18n.locale;
    let format = lan === 'es' ? 'dddd, D MMMM' : 'dddd, Do MMM';
    let date = Moment(this.params.date).locale(lan).format(format).toString()
    return date.charAt(0).toUpperCase() + date.slice(1)
  }

  get date () {
    return Moment(this.params.date).format('YYYY-MM-DD').toString();
  }

  get hasLesson() {
    return this.sections.id;
  }

  get hasContent() {
    return this.hasLesson || this.objectsTagged?.length > 0;
  }

  get menuAddOptions() {
    return [{
      type: 2,
      text: this.$t('common.folder'),
      icon: 'folder',
      borderBottom: false
    },{
      type: 2,
      text: this.$t('common.lesson'),
      icon: 'folder-solid',
      borderBottom: true
    }];
  }

  get viewer() {
    if (this.params.lesson) {
      const componentName = 'LESSON_CREATOR';

      if (COMPONENT_TYPE[componentName]) {
        return COMPONENT_TYPE[componentName].viewer;
      }
    }
    return null;
  }

  /* Methods */
  closeModal() {
    this.$EdModal.closeModal();
  }

  async getContent() {
    try {
      if(!this.params.lesson.createAsNew) {
        this.sections = await this.$Builder.Services.getLessonStructureById(this.params.lesson.id, this.params.builderId, this.params.courseId);
        this.sections.sections = this.removeTaggedInSections(this.sections.sections);
      } else {
        /* Fake lesson content */
        this.sections = {
          ...this.params.lesson,
          fixedSection: 'LESSON',
          label: `${this.$t('courses.subjectBuilder.lesson')} ${this.params.lesson.fixedSequence}`,
          name: `${this.$t('courses.subjectBuilder.lesson')} ${this.params.lesson.fixedSequence}`,
          type: 'SECTION',
          sections: []
        }
      }
      /*  Add tagged objects to sections */
      this.objectsTagged = this.params.objectsTagged
        .filter(el => el.schoolDate === this.params.lesson.startSchoolDate && el.showObject)
        .map(el => { return {
          ...el,
          sections: el.sections ? el.sections : []
        }});
        this.loading = false;
    } catch {
      this.loading = false;
    }
  }

  removeTaggedInSections(sections) {
    let sectionIds = [];
    let sectionsCopy = [...sections];
    sectionsCopy.forEach(sec => {
      if(this.params.objectsTagged.find(tag => tag.id == sec.id)) {
        sectionIds.push(sec.id);
      } else {
        if(sec.sections.length > 0) {
          sec.sections = this.removeTaggedInSections(sec.sections); 
        }
      }
    });
    sections = sections.filter(sec => !sectionIds.find(id => id === sec.id));
    return sections;
  }

  getTooltipTaggedObj(section) {
    return !section.movedByBuilder ? this.$t('courses.subjectBuilder.rulesContainer.tagObjectInfo', 
    { tag: this.$t(`common.tags.${section.labelSections.toLowerCase()}`),
      weekday: this.$t(`common.weekdays.${Moment(section.schoolDate).format('dddd').toLowerCase()}`) }) : '';
  }

  triggerAddFolder() {    
    this.addingSection = true;
  }

  goBack() {
    this.addingSection = false;
  }

  mounted() {
    this.getContent();
  }
}